import moment from "moment";
import dateTimeUtils from "utils/dateTimeUtils";
import { PeriodType, SessionSortEnum, type SessionView } from "../../../types/state";

export const defaultPeriodicRule = {
  periodType: PeriodType.Day,
  periodValue: 1,
};

export const getDefaultSession = (periodic: boolean): SessionView => {
  const step = 30;
  const normalizedTime = moment().add(step - (moment().minute() % step), "minutes");

  return {
    id: null,
    orderIndex: Infinity,
    timeZone: dateTimeUtils.getBrowserTimezone(),
    startDate: normalizedTime.format("MM/DD/yyyy"),
    startsAt: normalizedTime.format("hh:mm A"),
    endsAt: normalizedTime.add(step, "minutes").format("hh:mm A"),
    isPeriodic: periodic,
    webinarUrl: "",
    recurrenceSession: defaultPeriodicRule,
    registrationLimit: null,
    userRegistrationCount: null,
  };
};

export const getRecurringSession = (session: SessionView): SessionView => {
  const step = 30;
  const normalizedTime = moment().add(step - (moment().minute() % step), "minutes");

  return {
    id: null,
    orderIndex: Infinity,
    timeZone: dateTimeUtils.getBrowserTimezone(),
    startDate: session.startDate,
    startsAt: normalizedTime.format("hh:mm A"),
    endsAt: normalizedTime.add(step, "minutes").format("hh:mm A"),
    isPeriodic: true,
    webinarUrl: session.webinarUrl,
    recurrenceSession: { ...defaultPeriodicRule, seriesEndDate: session.recurrenceSession?.seriesEndDate },
    registrationLimit: session.registrationLimit,
    userRegistrationCount: null,
  };
};

export const sortSingleSessions = (sessions: SessionView[], orderBy: SessionSortEnum): SessionView[] => {
  return sessions.toSorted((a, b) => {
    switch (orderBy) {
      case SessionSortEnum.MostRecent:
        return a.orderIndex - b.orderIndex;
      case SessionSortEnum.StartDate:
        return new Date(a.startDate!).getTime() - new Date(b.startDate!).getTime();
      default:
        return 0;
    }
  });
};
